<template>
  <div>
    <b-button
      variant="gradient-primary"
      class="d-flex align-items-center"
      @click="addQuestion"
    >
      <span class="mr-1">سوال</span>
      <feather-icon icon="PlusIcon" />
    </b-button>
    <draggable
      v-model="questions"
      class="list-group list-group-flush cursor-move"
      tag="ul"
    >
      <b-list-group-item
        v-for="(question, index) in questions"
        :key="'question-' + index"
        tag="li"
      >
        <div class="d-flex justify-content-between">
          <span class="mr-2 font-weight-bold">{{ index + 1 }}.</span>
          <b-form-group label-for="add-question-active">
            <b-form-checkbox
              v-model="question.active"
              name="check-active"
              switch
              inline
              :uncheckedValue="0"
              :value="1"
            >
              وضعیت
            </b-form-checkbox>
          </b-form-group>
        </div>
        <b-form-group label="متن سوال" label-for="add-question-question">
          <validation-provider
            #default="{ errors }"
            name="question"
            vid="question"
            rules="required|min:4"
          >
            <b-form-input
              autocomplete="on"
              id="add-exercise-question"
              v-model="question.question"
              name="add-exercise-question"
              :state="errors.length > 0 ? false : null"
            />

            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group label="نوع سوال" label-for="add-question-type">
          <validation-provider
            #default="{ errors }"
            name="type"
            vid="type"
            rules="required"
          >
            <select-box
              v-model="question.type"
              label="name"
              select="value"
              :lists="types"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <select-option
          :qType="question.type"
          :qIndex="String(index)"
          v-model="question.items"
          :propItems="question.items"
          v-if="question.type && question.type != 2"
        />
        <b-form-group
          :label="question.type == 2 ? 'جواب' : 'توضیحات'"
          label-for="add-question-response"
          class="pt-2"
        >
          <validation-provider
            #default="{ errors }"
            name="response"
            vid="response"
            :rules="question.type == 2 ? 'required' : ''"
          >
            <b-form-textarea
              autocomplete="on"
              id="add-exercise-response"
              v-model="question.response"
              name="add-exercise-response"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            class="btn-icon rounded-circle my-1"
            @click="removeQuestion(index)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </div>
      </b-list-group-item>
    </draggable>
  </div>
</template>

<script>
import {
  BListGroupItem,
  BButton,
  BFormGroup,
  BFormInput,
  BBadge,
  BFormCheckbox,
  BFormTextarea,
} from "bootstrap-vue";
import draggable from "vuedraggable";
import SelectBox from "@/@core/components/select-box/SelectBox.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import Ripple from "vue-ripple-directive";
import SelectOption from "./SelectOption.vue";
import Editor from "@/@core/components/editor/Editor.vue";

export default {
  props: {
    propQuestions: {
      type: Array,
      default: () => [],
    },
  },
  directives: {
    Ripple,
  },
  components: {
    draggable,
    BListGroupItem,
    BButton,
    SelectBox,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BBadge,
    SelectOption,
    BFormCheckbox,
    Editor,
    BFormTextarea,
  },
  data() {
    return {
      required,
      questions: [],
      types: [
        {
          name: "چند گزینه ای",
          value: "0",
        },
        {
          name: "چهار گزینه ای",
          value: "1",
        },
        {
          name: "تشریحی",
          value: "2",
        },
        {
          name: "بله خیر",
          value: "3",
        },
      ],
    };
  },
  created() {
    this.questions = [...this.propQuestions];
  },
  watch: {
    questions: {
      async handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    addQuestion() {
      this.questions.push({ active: 0, type: "" });
    },
    removeQuestion(i) {
      this.questions.splice(i, 1);
    },
  },
};
</script>
